import ajax from './ajax';
import axios from 'axios'

class HttpClient {
api_url = '';

constructor() {
// this.api_url = 'http://localhost:8000/'
this.api_url = 'http://ec2-35-175-178-10.compute-1.amazonaws.com/'
}

generateHeader() {
const headers = {
headers: {
"Content-Type": "application/json",
"Accept": "application/json",

}
};
return headers;
}

async fbPageAnalytics(body) {

return ajax('/resources/facebook-page' + '?' + 'start_date=' + body.start_date + '&' + 'end_date=' + body.end_date + '&' + 'id=' + body.user_id)
}



async fbPostAnalytics(body) {
return ajax('/resources/facebook-post' + '?' + 'start_date=' + body.start_date + '&' + 'end_date=' + body.end_date + '&' + 'id=' + body.user_id)
}

async instaPageAnalytics(body) {
return ajax('/resources/insta-page' + '?' + 'start_date=' + body.start_date + '&' + 'end_date=' + body.end_date + '&' + 'id=' + body.user_id)
}

async instaPostAnalytics(body) {
return ajax('/resources/insta-post' + '?' + 'start_date=' + body.start_date + '&' + 'end_date=' + body.end_date + '&' + 'id=' + body.user_id)
}

async ytChannelsAnalytics(body) {
return ajax('/resources/youtube-page' + '?' + 'start_date=' + body.start_date + '&' + 'end_date=' + body.end_date + '&' + 'id=' + body.user_id)
}

async ytVideosAnalytics(body) {
return ajax('/resources/youtube-post' + '?' + 'start_date=' + body.start_date + '&' + 'end_date=' + body.end_date + '&' + 'id=' + body.user_id)
}

async linkedInPageAnalytics(body) {
return ajax('/resources/linkedin-page' + '?' + 'start_date=' + body.start_date + '&' + 'end_date=' + body.end_date + '&' + 'id=' + body.user_id)
}

async linkedInPostAnalytics(body) {
return ajax('/resources/linkedin-post' + '?' + 'start_date=' + body.start_date + '&' + 'end_date=' + body.end_date + '&' + 'id=' + body.user_id)
}

async twitterPageAnalytics(body) {
return ajax('/resources/twitter-page' + '?' + 'start_date=' + body.start_date + '&' + 'end_date=' + body.end_date + '&' + 'id=' + body.user_id)
}

async twitterPostAnalytics(body) {
return ajax('/resources/twitter-post' + '?' + 'start_date=' + body.start_date + '&' + 'end_date=' + body.end_date + '&' + 'id=' + body.user_id)
}

async fetchCalendarData(body) {
return ajax('/resources/calendar-page')
}

async getScheduledPosts({ startDate, endDate }) {
  const url  =`/resources/get-calendar-posts/?start=${startDate}&end=${endDate}`; 
  return ajax(url, { method: 'GET'})
}

async getScheduledStories({ startDate, endDate }) {
  const url  =`/resources/get-stories-posts/?start=${startDate}&end=${endDate}`; 
  return ajax(url, { method: 'GET'})
}

async fetchDashboardData(body) {

return ajax('/resources/dashboard-page' + '?start_date=' + body.startDate + '&end_date=' + body.endDate + '&user_ids=' + body.user_ids)
}

async fetchFbPostsList(body) {
return ajax('/resources/facebook-feed'+ '?' + 'id=' + body.id)
}

async fetchInstaPostsList(body) {

return ajax('/resources/get-insta-feed' + '?' + 'id=' + body.id)
}

async fetchYoutubeVideos(body) {

return ajax('/resources/get-channel-videos' + '?' + 'id=' + body.id)
}

async getTweets(body) {

return ajax('/resources/get-tweets' + '?' + 'id=' + body.id)
}

async getLinkedInPosts(body) {

return ajax('/resources/get-linkedin-post' + '?' + 'id=' + body.id)
}


  async getUserManagerList(body) {
   
    return await axios.get(this.api_url + 'get_brandcil_user_from_database')
  }
  async createUserManager(body) {
    
    return await axios.post(this.api_url + 'create_user_data', body, this.generateHeader())
  }
  async editUserManager(body) {
    
    return await axios.put(this.api_url + 'edit-user', body, this.generateHeader())
  }
  async deleteUserManager(body) {
    
    return await axios.put(this.api_url + 'delete-user', body, this.generateHeader())
  }
  async postApprovalPageAnalytics(body) {
    
    let result = await axios.get(this.api_url + 'get-post-approval')
    
    return result;

  }
  
  async fetchLinkMetadata(body) {
    return ajax(`/resources/fetch-link-metadata/?url=${body}`)
  }

}



export default new HttpClient();
